module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_COLOSTRUM.be5fe05a.png";